export default function parseJson(val: any) {
  if (val === null || val === undefined) return null;
  if (typeof val === "object") return val;
  try {
    return JSON.parse(val) ?? null;
  } catch (e) {
    return null;
  }
}
